import React from 'react';
import WelcomeImage from './WelcomeImage';

// Rebuild legacy markup as React elements. No source HTML/attributes are inserted.
const allowed = new Set(['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'S', 'H1', 'H2', 'H3', 'H4', 'UL', 'OL', 'LI', 'BLOCKQUOTE', 'A', 'DIV', 'SPAN', 'PRE', 'CODE', 'H5', 'H6', 'SUP', 'SUB', 'HR']);
const discard = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'SVG', 'MATH', 'FORM', 'INPUT', 'TEMPLATE']);
function safeLink(value) {
  try { const url = new URL(value); return ['https:', 'http:', 'mailto:'].includes(url.protocol) && !url.username && !url.password ? url.href : undefined; } catch { return undefined; }
}
function nodes(parent) {
  return Array.from(parent.childNodes).map((node, i) => {
    if (node.nodeType === 3) return node.textContent;
    if (node.nodeType !== 1 || discard.has(node.tagName)) return null;
    if (node.tagName === 'IMG') {
      const src = safeLink(node.getAttribute('src'));
      return src && /^https?:/.test(src) ? <WelcomeImage key={i} src={src} alt={node.getAttribute('alt') || ''} className="max-w-full rounded-xl" loading="lazy" /> : null;
    }
    const children = nodes(node);
    if (!allowed.has(node.tagName)) return <React.Fragment key={i}>{children}</React.Fragment>;
    const props = { key: i };
    if (node.tagName === 'A') { props.href = safeLink(node.getAttribute('href')); props.rel = 'noopener noreferrer'; }
    return React.createElement(node.tagName.toLowerCase(), props, ...(['BR', 'HR'].includes(node.tagName) ? [] : children));
  });
}
export function welcomePlainText(value) {
  const doc = new DOMParser().parseFromString(value || '', 'text/html');
  doc.querySelectorAll('script,style,iframe,object,embed,svg,math,form,template').forEach(node => node.remove());
  doc.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
  doc.querySelectorAll('p,h1,h2,h3,h4,li,blockquote,div').forEach(node => node.append('\n'));
  return doc.body.textContent.trim();
}
export default function WelcomeContent({ value = '', format = 'text' }) {
  if (format === 'text' || !/<\/?[a-z][\s\S]*>/i.test(value)) return <div className="whitespace-pre-wrap text-gray-700">{value}</div>;
  const doc = new DOMParser().parseFromString(value, 'text/html');
  return <div className="prose prose-sm sm:prose-base max-w-none text-gray-700">{nodes(doc.body)}</div>;
}
